import PageHeading from '@v2/shared/components/PageHeading';
import SearchBox from './SearchBox';
import { HelpKustomer } from './types';

/**
 * The Customer Care band: the heading on every /help page, and on /contact.
 *
 * One component because the two pages had drifted into two copies of the same heading
 * with a different button, placeholder and popular-links treatment each. The intro and
 * the H1 are each page's own; the rest is here.
 */
export default function Band({
  title,
  intro,
  meta,
  hero,
  searchAction,
  kustomer,
  categoryTitles,
  query,
  popular,
}: {
  title: string;
  intro?: string;
  meta?: string;
  /** /contact's taller band, which its at-a-glance strip is pulled up over. */
  hero?: boolean;
  searchAction: string;
  kustomer?: HelpKustomer;
  categoryTitles?: Record<string, string>;
  query?: string;
  /**
   * Rendered as given, so the caller builds each href: /contact's include an anchor on
   * its own page, which buildUrl would turn into one on the home page.
   */
  popular?: { href: string; label: string }[];
}) {
  return (
    <PageHeading
      hero={hero}
      eyebrow="Customer Care"
      intro={intro || undefined}
      actions={
        <div className="w-full">
          <SearchBox action={searchAction} kustomer={kustomer} categoryTitles={categoryTitles} query={query} />

          {popular && popular.length > 0 ? (
            <div className="mt-3 flex flex-wrap items-center gap-2">
              <span className="text-[13px] font-semibold">Popular:</span>
              {popular.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="inline-block rounded-full border border-solid border-white/35 bg-white/[0.16] px-3 py-1.5 text-[13px] font-semibold text-white no-underline hover:bg-white/25"
                >
                  {link.label}
                </a>
              ))}
            </div>
          ) : null}

          {meta ? <p className="mb-0 mt-3 text-[13px] opacity-80">{meta}</p> : null}
        </div>
      }
    >
      {title}
    </PageHeading>
  );
}
